import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/auth')({
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <>
      <div
        style={{
          minHeight: '100vh',
          // The page wash lives on <body> (theme globalCss) — see _protected.tsx.
          background: 'transparent',
        }}
      >
        <Outlet />
      </div>
    </>
  )
}
